import React from 'react';
import './FormSection.css';

interface FormSectionProps {
  sectionNumber: number;
  title: string;
  isExpanded: boolean;
  isComplete: boolean;
  completedCount?: number;
  totalCount?: number;
  onToggle: () => void;
  children: React.ReactNode;
}

const FormSection: React.FC<FormSectionProps> = ({
  sectionNumber,
  title,
  isExpanded,
  isComplete,
  completedCount = 0,
  totalCount = 0,
  onToggle,
  children,
}) => {
  return (
    <section
      className={`form-section ${isExpanded ? 'expanded' : 'collapsed'} ${
        isComplete ? 'completed' : ''
      }`}
      data-section={sectionNumber}
    >
      <div className="section-header" onClick={onToggle}>
        <div className="section-title-wrapper">
          <h2 className="section-title">{title}</h2>
          <span className="section-status" style={{ display: 'none' }}>
            {completedCount}/{totalCount} completed
          </span>
        </div>
        <button type="button" className="section-toggle" aria-label="Toggle section">
          <span className="toggle-icon">{isExpanded ? '▼' : '▶'}</span>
        </button>
      </div>
      {isExpanded && <div className="section-content">{children}</div>}
    </section>
  );
};

export default FormSection;




